import { IEntity } from './IEntity';

export const resourceNameGoalDataPoint = `goaldatapoint`;

export interface IGoalDataPoint extends IEntity {
	goalid: number;
    value: number;
    comment: string;
    egoaldatapointtype: number;
}

export const maxDatapointAgeForDaysLeft = 30;